import player from './player';
import game from './game';

export default { player, game };



// WEBPACK FOOTER //
// ./src/command/index.js